import { ErrorText } from "./ErrorText";

export default ErrorText;
